import getRandomValue from '../../utils/getRandomValue'
import {
	ARRIVAL_AIRPORT_CHANGE,
	ARRIVING_DIFFERENT,
	COSTING_INFO,
	CRED_GCM_MAL_IMAGE,
	DEPARTURE_AIRPORT_CHANGE,
	DEPARTURE_DATE_CHANGED,
	DROP_DOWN_COLLAPSE,
	GCM_BANNER_IMAGE,
	GCM_INDIAN_CITIES,
	GCM_PASSENGER_INFO,
	GCM_REGION_STATS,
	GCM_RESET_DEFAULT_LOGIN,
	GCM_RESET_PASSENGER_INFO,
	GCM_SIGNUP_FAILS,
	GCM_SIGNUP_FAILS_RESET,
	INTL_FLIGHTS_BOOKED,
	LOGIN_ERROR,
	NATIONALITY_GLOBAL,
	SET_ENABLE_GET_COST,
	SET_LOADING,
	SET_STAY_DURATION,
	TRAVEL_TYPE,
	UPDATE_COSTING,
	USER_INTENT,
} from './Constants'
import { getCostingBasedOntype } from './utils/getCostingText'
import isEnableGetCost from './utils/isEnableGetCost'
import isExpiredDate from './utils/isExpiredDate'

const GCMState = (state, action) => {
	switch (action.type) {
		case COSTING_INFO: {
			if (action.payload) {
				return {
					...state,
					...action.payload,
				}
			}
			return state
		}
		case DROP_DOWN_COLLAPSE: {
			if (action.payload) {
				return {
					...state,
					...action.payload,
				}
			}
			return state
		}
		case SET_STAY_DURATION: {
			return {
				...state,
				...action.payload,
			}
		}
		case SET_ENABLE_GET_COST: {
			const { itineraryInfo = {}, isLoggedIn } = action.payload
			const {
				departureAirport,
				arrivalAirport,
				departureDate,
				nights = 3,
				nationality,
				hotelGuestRoomConfigurations,
				flightsBookedByUserAlready = false,
				userIntent,
				passenger_details,
			} = state
			return {
				...state,
				departureAirport: nationality ? '$$$' : state.departureAirport,
				arrivalAirport: nationality ? '$$$' : state.arrivalAirport,
				enableGetCost: isEnableGetCost({
					itineraryInfo,
					gcmData: {
						flightsBookedByUserAlready: flightsBookedByUserAlready,
						departureCity: departureAirport,
						arrivalCity: arrivalAirport,
						date: departureDate,
						nights: nights,
						roomConfigurations: hotelGuestRoomConfigurations,
						hotelGuestRoomConfigurations,
						nationalityCode: nationality,
						userIntent,
						passenger_details,
					},
					locale: '',
					isLoggedIn,
				}),
				dateExpired: isExpiredDate(departureDate),
			}
		}
		case SET_LOADING: {
			return {
				...state,
				isLoading: true,
			}
		}
		case ARRIVAL_AIRPORT_CHANGE: {
			return {
				...state,
				...action.payload,
			}
		}
		case NATIONALITY_GLOBAL: {
			return {
				...state,
				nationality: action.payload,
			}
		}
		case DEPARTURE_AIRPORT_CHANGE: {
			let { isArrivingDifferent, arrivalAirport } = state
			const { departureAirport } = action.payload
			arrivalAirport = isArrivingDifferent ? arrivalAirport : departureAirport
			return {
				...state,
				...action.payload,
				arrivalAirport,
			}
		}
		case DEPARTURE_DATE_CHANGED: {
			return {
				...state,
				...action.payload,
			}
		}
		case INTL_FLIGHTS_BOOKED: {
			return {
				...state,
				...action.payload,
				departureAirport: '$$$',
				arrivalAirport: '$$$',
				isArrivingDifferent: false,
				flightsBookedByUserAlready: true,
			}
		}
		case ARRIVING_DIFFERENT: {
			if (state.isArrivingDifferent !== action.payload) {
				return {
					...state,
					isArrivingDifferent: action.payload,
					arrivalAirport: state.departureAirport,
				}
			}
			return state
		}
		case CRED_GCM_MAL_IMAGE: {
			return {
				...state,
				...action.payload,
			}
		}
		case GCM_BANNER_IMAGE: {
			const { images = [], contents = [] } = action.payload
			let value = getRandomValue(0, images.length - 1)
			return {
				...state,
				bannerImageUrl: images[value],
				bannerContent: contents[value] || null,
			}
		}
		case TRAVEL_TYPE: {
			const { travelType } = action.payload
			const currentTravelType = state.travelType || ''
			return {
				...state,
				...action.payload,
				hotelGuestRoomConfigurations:
					action.payload.maintainSameConfig || currentTravelType === travelType
						? state.hotelGuestRoomConfigurations
						: getCostingBasedOntype(action.payload.travelType),
			}
		}
		case USER_INTENT: {
			return {
				...state,
				userIntent: action.payload,
			}
		}
		case GCM_INDIAN_CITIES: {
			return {
				...state,
				cities: action.payload,
			}
		}
		case UPDATE_COSTING: {
			return {
				...state,
				...action.payload,
			}
		}
		case GCM_REGION_STATS:
			return {
				...state,
				regionStats: action.payload,
			}
		case GCM_PASSENGER_INFO:
			return {
				...state,
				passenger_details: {
					...state.passenger_details,
					...action.payload,
				},
			}
		case GCM_SIGNUP_FAILS_RESET:
			return {
				...state,
				defaultLoginData: {},
			}
		case GCM_SIGNUP_FAILS:
			return {
				...state,
				defaultLoginData: {
					...state.defaultLoginData,
					...action.payload,
				},
			}
		case LOGIN_ERROR:
			return {
				...state,
				loginError: {
					...state.loginError,
					...action.payload,
				},
			}

		case GCM_RESET_PASSENGER_INFO:
			return {
				...state,
				defaultLoginData: {},
				passenger_details: {},
				loginError: {},
			}

		case GCM_RESET_DEFAULT_LOGIN:
			return {
				...state,
				defaultLoginData: {},
			}
		default:
			return state
	}
}

export default GCMState
